module.exports = __webpack_public_path__ + "img/Burger and drink Icon - charcoal.8e230f15.svg";